export default "__VITE_ASSET__119a94e9__"